import axiosInstance from "../services/axiosInstance";

export const getUsers = async ({
  companyId,
  page = 1,
  perPage = 10,
  search = "",
  status = "Active",
}) => {
  try {
    const response = await axiosInstance.get(`console/user/get`, {
      params: {
        company_id: companyId,
        page,
        perPage,
        search,
        status,
      },
    });

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const getUserInfo = async (idPersonnel) => {
  try {
    const response = await axiosInstance.get(
      `console/workspace/user/get?personnel_id=` + idPersonnel,
    );

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const editUser = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `console/workspace/user/edit`,
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const updatePaidLeave = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `console/workspace/user/paidleave`,
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const updateSalary = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `console/workspace/user/salary`,
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const fetchSelectPersonnels = async (
  company_id,
  search = null,
  defaultValue = null,
) => {
  try {
    const response = await axiosInstance.get(
      "console/workspace/user/select?company_id=" +
        company_id +
        "&search=" +
        search +
        "&default=" +
        defaultValue,
    );

    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const ValidateImportUsers = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/user/import/validate",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const SubmitImportUsers = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/user/import/submit",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getUserRoles = async () => {
  try {
    const response = await axiosInstance.get("console/user/roles");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const updateUserRole = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/user/role/update",
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const deactivateUser = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/user/deactivate",
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const reactivateUser = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/user/reactivate",
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Unknown error" };
  }
};

export const fetchDepartmentSuggestions = async (companyId, search = "") => {
  try {
    const response = await axiosInstance.get("console/user/departments", {
      params: {
        company_id: companyId,
        search,
      },
    });

    return response.data;
  } catch (error) {
    return error.response?.data || { status: 500, data: [] };
  }
};
